import React from 'react';

import { Button } from './styles';

interface ButtonProps{
  onClick:()=> void,
  children: any,
}

const ButtonCancel: React.FC<ButtonProps> = (props) => {
  return (
    <Button
      onClick={props.onClick}
    >
      {props.children}
    </Button>
  );
};

  export default ButtonCancel;
